import SectionLabel from "@/components/base/SectionLabel";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function ExamplesSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10 reveal">
          <SectionLabel label={aiDigitalData.examples.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            {aiDigitalData.examples.title}
          </h2>
        </div>

        <div className="max-w-2xl mx-auto">
          {aiDigitalData.examples.items.map((item, idx) => (
            <div
              key={idx}
              className="reveal flex items-start gap-3 py-3 md:py-3.5 border-b border-background-200/50 last:border-b-0"
              style={{ transitionDelay: `${idx * 50}ms` }}
            >
              <div className="w-6 h-6 rounded-full bg-primary-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-chat-3-line text-primary-500 text-xs" />
              </div>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                {item}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-foreground-500 mt-6 reveal">
          これ以外のご相談もお気軽にお問い合わせください
        </p>
      </div>
    </section>
  );
}